module.exports = __webpack_public_path__ + "img/bus-outline-blue-default.a727258c.svg";